import { Action, createReducer, on } from "@ngrx/store";

import * as ReportsActionTypes from "../../actions/reports/reports.actions";

import { ReportDTO, ReportListDTO } from "src/app/models/reports/ReportDTO";
import { ReportStatusDTO } from "src/app/models/reports/ReportStatusDTO";
import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";

export interface ReportsState {
  reportsList: ReportListDTO[];
  isLoading: boolean;
  error: Error;
  report: ReportDTO;
  reportStatusList: ReportStatusDTO[];
  reportStatusExcelList: ReportStatusDTO[];
  totalReportStatus: number;
  reportStatusTableConfig: ColumnSorterInfo[];
}

export const initialState: ReportsState = {
  reportsList: null,
  isLoading: false,
  error: null,
  report: null,
  reportStatusList: null,
  reportStatusExcelList: null,
  totalReportStatus: null,
  reportStatusTableConfig: null,
};

const reportsReducer = createReducer(
  initialState,
  on(ReportsActionTypes.resetReportState, () => initialState),
  on(ReportsActionTypes.loadReportsList, (state, { response }) => {
    return {
      ...state,
      reportsList: (response as any).result
        ? (response as any).result
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(ReportsActionTypes.loadGeneratedReport, (state, { response }) => {
    return {
      ...state,
      report: (response as any) ? (response as any) : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(ReportsActionTypes.getReportStatusList, (state, { options }) => {
    return {
      ...state,
      error: null,
      options: options,
      isLoading: true,
    };
  }),
  on(ReportsActionTypes.loadReportStatusList, (state, { response }) => {
    return {
      ...state,
      reportStatusList: (response as any)?.result?.items
        ? (response as any)?.result?.items
        : undefined,
      isLoading: false,
      error: null,
      totalReportStatus: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
    };
  }),
  on(ReportsActionTypes.getReportStatusExcelList, (state, { options }) => {
    return {
      ...state,
      error: null,
      options: options,
      isLoading: true,
    };
  }),
  on(ReportsActionTypes.loadReportStatusExcelList, (state, { response }) => {
    return {
      ...state,
      reportStatusExcelList: (response as any)?.result?.items
        ? (response as any)?.result?.items
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(ReportsActionTypes.getReportStatusTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    }
  }),
  on(ReportsActionTypes.loadReportStatusTableConfig, (state, { response }) => {
    return {
      ...state,
      reportStatusTableConfig: (response as any)?.result?.value?.tableColumnInfo ?? undefined,
    };
  }),
  on(ReportsActionTypes.saveReportStatusTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(ReportsActionTypes.getReportData, (state) => {
    return {
      ...state,
      isLoading: true,
      error: null,
    };
  }),
  on(ReportsActionTypes.loadReportData, (state, { response }) => {
    return {
      ...state,
      report: (response as any).result ? (response as any).result : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(ReportsActionTypes.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  })
);

export function reducer(state: ReportsState | undefined, action: Action) {
  return reportsReducer(state, action);
}
